import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import i18n from 'src/utils/translate';
import { createSlug } from 'src/utils/string';
import { trackFootfallEvent } from 'src/utils/footfall';
import footfallEventTypes from 'src/constants/footfallEventTypes';
import Card from 'src/components/card';
import config from 'config/config';
import Link from 'next/link';

const CardHeading = styled.div`
  display: flex;
  margin-bottom: 10px;
`;
const PollGraphic = styled.img`
  width: 100%;
  height: 100%;
`;
const IconWrapper = styled.div`
  flex-shrink: 0;
  width: 30px;
  height: auto;
  margin: 0 10px 4px 5px;
`;
const Heading = styled.h3`
  margin-bottom: 0;
`;

const CommunityLatestPoll = ({ widget, community, seeAllOnClick = () => {} }) => {
  const pollLinkAs = `/${community.slug}/polls/${widget.pollId}/${createSlug(widget.title)}`;
  const pollLinkHref = `/community/poll?context=${community.slug}&id=${widget.pollId}&slug=${createSlug(widget.title)}`;

  return (
    <Card
      seeAllLink={`/${community.slug}/polls`}
      seeAllOnClick={(e) => {
        seeAllOnClick(e);
        trackFootfallEvent(footfallEventTypes.CLICKED, {
          clickType: 'community-see-all-polls',
          clickMetadata: { section: 'community-side-bar' },
        });
      }}
      seeAllText={i18n.t('See all polls')}
      title={i18n.t('Latest poll')}
    >
      <div className="community__widget__latest-poll">
        <CardHeading>
          <IconWrapper>
            <PollGraphic alt="Poll icon" src={`${config.cdn.static}img/icon-poll.png`} />
          </IconWrapper>
          <Heading className="results-post__title">
            <Link
              as={pollLinkAs}
              href={pollLinkHref}
            >
              <a onClick={() => {
                trackFootfallEvent(footfallEventTypes.CLICKED, {
                  clickType: 'community-latest-poll',
                  clickMetadata: {
                    section: 'community-side-bar',
                    element: 'poll-title',
                  },
                });
              }}>
                {widget.title}
              </a>
            </Link>
          </Heading>
        </CardHeading>
        <Link
          as={pollLinkAs}
          href={pollLinkHref}
        >
          <a
            className="btn btn-secondary community__widget__actions"
            onClick={() => {
              trackFootfallEvent(footfallEventTypes.CLICKED, {
                clickType: 'community-latest-poll',
                clickMetadata: {
                  section: 'community-side-bar',
                  element: 'poll-button',
                },
              });
            }}
          >
            {i18n.t('Vote')}
          </a>
        </Link>
      </div>
    </Card>
  );
};

CommunityLatestPoll.propTypes = {
  community: PropTypes.object.isRequired,
  widget: PropTypes.object.isRequired,
  seeAllOnClick: PropTypes.func,
};

CommunityLatestPoll.defaultProps = {
  seeAllOnClick: () => {},
};

export default CommunityLatestPoll;
